import React from 'react';

import { Link, Text } from '@change/ds-core-ui';
import { ArrowUpIcon } from '@change/ds-icons';
import { cn } from '@change/ds-utils';

import { isValidUrl, normalizeUrlForHref, shouldHighlightText } from '../../helpers/validation';

type LinkContentProps = {
	name: string;
	link: string | undefined;
	isPlaceholder: boolean;
	hasFocus: boolean;
};

export const LinkContent: React.FC<LinkContentProps> = ({ name, link, isPlaceholder, hasFocus }) => {
	const shouldHighlight = shouldHighlightText(hasFocus, !isPlaceholder);

	const content = (
		<div className="flex flex-row gap-1.5">
			<Text
				variant="body"
				fontWeight="bold"
				size="large"
				className={cn(
					isPlaceholder && 'text-typography-strong! underline decoration-solid decoration-auto',
					shouldHighlight && 'text-typography-interactive!',
				)}
			>
				{name}
			</Text>
			<div className="rotate-45 [&_svg]:h-[12px] [&_svg]:w-[12px]">
				<ArrowUpIcon />
			</div>
		</div>
	);

	// Only render as a link if the URL is valid
	if (!isValidUrl(link)) {
		return content;
	}

	return (
		<Link href={normalizeUrlForHref(link)} variant="secondary">
			{content}
		</Link>
	);
};
